"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressOfProductFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _lodash = _interopRequireDefault(require("lodash"));
var _formik = require("formik");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AddressOfProductFields = undefined;
exports.AddressOfProductFields = AddressOfProductFields;
try {
  var DefaultAddressOfProductFields = require("react-platform-address-of-product/dist/AddressOfProduct/AddressOfProductFields").default;
  exports.AddressOfProductFields = AddressOfProductFields = function AddressOfProductFields(props) {
    var _useFormikContext = (0, _formik.useFormikContext)(),
      initialValues = _useFormikContext.initialValues,
      initialErrors = _useFormikContext.initialErrors,
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(DefaultAddressOfProductFields, _extends({}, props, {
      values: values,
      unusedFields: ["state"],
      isForced: true,
      defaultLatLng: {
        lat: 48.85944541502537,
        lng: 2.2937077942430535
      },
      zoom: 10,
      initialErrors: initialErrors,
      initialValues: initialValues,
      setFieldValue: setFieldValue
    }))));
  };
} catch (error) {}